import React, { Component, useEffect } from 'react';
import Main from "./components/Main.jsx";
import HomePage from "./components/HomePage.jsx";
import SharePage from "./components/SharePage.jsx";
import LegacyRedirect from "./components/LegacyRedirect.jsx";
import AboutPage from "./components/AboutPage.jsx";
import PrivacyPage from "./components/PrivacyPage.jsx";
import ShippingPage from "./components/ShippingPage.jsx";
import AdminPage from "./components/admin/AdminPage.jsx";
import TrailMapsPage from "./components/TrailMapsPage.jsx";
import RoadTripPage from "./components/RoadTripPage.jsx";
import MyMapsPage from "./components/MyMapsPage.jsx";
import { Provider, useDispatch } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from "./auth/AuthContext";
import AuthDialog from "./auth/AuthDialog.jsx";

import './App.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import configureStore from "./store/configureStore";
import { theme } from "./theme";
import { captureUrlPromoCode, hydratePromos } from "./actions/promoActions";

const store = configureStore();

/**
 * Boots promo state once per session:
 *   1. Read `?promo=` from the URL (or restore from sessionStorage).
 *   2. Fetch the active promo list from Firestore so the resolver has
 *      everything it needs to decide whether to swap product SKUs.
 *
 * Rendered inside <Provider> so dispatch is available. Renders nothing.
 */
const PromoBootstrapper = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(captureUrlPromoCode());
        dispatch(hydratePromos());
    }, [dispatch]);
    return null;
};

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                {/* No <Helmet> here. In this client-only CRA + React 18 app,
                    react-helmet / -async flushed head changes unreliably on the
                    initial render (pages were left on index.html's default title).
                    Per-page <title> is now set imperatively via useDocumentTitle
                    (function pages) / Main.syncTitle (class); site-wide
                    description/og/canonical live statically in public/index.html. */}
                <BrowserRouter>
                        <ThemeProvider theme={theme}>
                            <CssBaseline />
                            <AuthProvider>
                            <PromoBootstrapper />
                            <div>
                                <Routes>
                                    <Route path="/s/:id" element={<SharePage />} />
                                    {/* `key` forces React to remount Main when the tool
                                        changes — otherwise the same instance is reused across
                                        these two routes and Main's constructor (which reads
                                        `tool` to seed activeTab) never re-runs. */}
                                    <Route path="/travel-maps"  element={<Main key="travel" tool="travel" />} />
                                    <Route path="/photo-shaper" element={<Main key="shaper" tool="shaper" />} />
                                    <Route path="/about" element={<AboutPage />} />
                                    <Route path="/privacy" element={<PrivacyPage />} />
                                    <Route path="/shipping" element={<ShippingPage />} />
                                    <Route path="/admin" element={<AdminPage />} />
                                    <Route path="/trail-maps" element={<TrailMapsPage />} />
                                    <Route path="/road-trips" element={<RoadTripPage />} />
                                    <Route path="/my-maps" element={<MyMapsPage />} />
                                    <Route path="/" element={<LegacyRedirect />} />
                                    <Route path="*" element={<HomePage />} />
                                </Routes>
                                <ReduxToastr
                                    transitionIn="fadeIn"
                                    transitionOut="fadeOut"
                                />
                                <AuthDialog />
                            </div>
                            </AuthProvider>
                        </ThemeProvider>
                    </BrowserRouter>
            </Provider>
        );
    }
}

export default App;
